import { Box, Stack } from '@chakra-ui/react';
import { useLingui } from '@lingui/react/macro';

import { Link } from '#features/routing';
import { GhostIcon, Placeholder } from '#features/ui';

/**
 * Экран ошибки — лучший момент поймать баг: человек уже столкнулся с ним и ещё помнит, что делал.
 * Поэтому рядом с «на главную» стоит вход в обратную связь; форма приложит экран и версию сама,
 * так что писать «где это было» не придётся.
 *
 * Тексты — фразами, а не кодами: этот экран показывается в том числе после неудачной загрузки
 * чанков, когда каталог переводов не приехал (он и сам отдельный чанк). С кодом в качестве
 * идентификатора человек читал бы «common:pageWasNotLoaded» — см. UpdateInProgress.
 */
export const ErrorWarning = () => {
  const { t } = useLingui();

  return (
    <Box w="100%">
      <Placeholder icon={GhostIcon}>
        <Placeholder.Title>{t`We couldn't load this page`}</Placeholder.Title>
        <Stack direction={{ base: 'column', sm: 'row' }} gap={3}>
          <Placeholder.Button asChild>
            <Link to="/{-$locale}">{t`Go home`}</Link>
          </Placeholder.Button>
          <Placeholder.Button asChild variant="outline">
            <Link to="/{-$locale}/feedback">{t`Report a problem`}</Link>
          </Placeholder.Button>
        </Stack>
      </Placeholder>
    </Box>
  );
};
